import * as React from 'react';

import { SvgUse } from 'src/shoppe/elements/SvgUse';
import { LazyImgix } from 'src/explore/elements/LazyImgix';
import { isValidUrl } from '../../services';

import styles from './index.module.sass';

interface LogoProps {
  logoUrl?: string;
}

export const Logo: React.FC<LogoProps> = ({ logoUrl }) => {
  if ( isValidUrl( logoUrl )) {
    return <LazyImgix src={logoUrl} alt="Goldbelly" className={styles.imgLogo} />;
  }

  return (
    <SvgUse
      ariaLabel="Goldbelly"
      className={`${styles.logo} position-absolute`}
      height={68}
      name="goldbelly-stacked"
      width={110}
    />
  );
};
